import { RouteRecordRaw } from "vue-router";
import CustomerSupportDashboard from "@/pages/customerSupport/CustomerSupportDashboard.vue";
import TicketPanel from "../components/customerSupport/TicketPanel.vue";

const customerSupportRoutes: RouteRecordRaw = {
  name: "customerSupport",
  path: "/customer-support/:customerId/tickets",
  component: CustomerSupportDashboard,
  props: true,
  meta: {
    authenticated: true,
    title: `Customer Support`,
    breadcrumbs: [{ label: "Customer Support" }, { label: "Customer Support Dashboard", on: ["customerSupport"] }],
  },
  children: [
    {
      name: "newTicket",
      path: "new",
      component: TicketPanel,
      meta: { authenticated: true },
      props: true,
    },
    {
      name: "ticket",
      path: ":ticketId",
      component: TicketPanel,
      meta: { authenticated: true },
      props: true,
    },
    {
      name: "editTicket",
      path: ":ticketId/edit",
      component: TicketPanel,
      meta: { authenticated: true },
      props: true,
    },
  ],
};

export default customerSupportRoutes;
